import { Location, NgClass, UpperCasePipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { TabTypeStringPipe } from '../../../_common/pipes/tabType-string.pipe';
import { ReservationDetailsTabType } from './../enum/resDetailsTabsType.enum';
import { ReservationDetails } from './../model/reservation-details';
import { ResReservationCommComponent } from './res-reservation-comm/res-reservation-comm.component';
import { ResReservationDocumentsComponent } from './res-reservation-documents/res-reservation-documents.component';
import { ResReservationStatusComponent } from './res-reservation-status/res-reservation-status.component';

@Component({
    selector: 'res-reservation-details',
    templateUrl: './res-reservation-details.component.html',
    styleUrls: ['./res-reservation-details.component.scss'],
    imports: [
        NgClass,
        ResReservationStatusComponent,
        ResReservationDocumentsComponent,
        ResReservationCommComponent,
        UpperCasePipe,
        TabTypeStringPipe,
    ],
})
export class ResReservationDetailsComponent {
    private location = inject(Location);

    public reservationDetails: ReservationDetails;
    public selectedTab: ReservationDetailsTabType;
    public reservationsTabs: ReservationDetailsTabType[] = Object.values(ReservationDetailsTabType);

    @Input() set setData(value: { reservationDetails: ReservationDetails; selectedTab: ReservationDetailsTabType }) {
        this.reservationDetails = value.reservationDetails;
        this.selectTab(value.selectedTab || ReservationDetailsTabType.STATUS);
    }
    public selectTab(selectedTab: ReservationDetailsTabType) {
        this.selectedTab = selectedTab;
        if (this.location.path()?.includes('/reservations-list/reservation'))
            this.location.go(`reservations-list/reservation/${this.reservationDetails.caseId}/${selectedTab}`);
    }
}
